const StationStatus = {
  Active: "active",
  Closed: "closed",
};

export { StationStatus };
